import { CityFilter } from './city-filter'
import { DateFilter } from './date-filter'
import { GenreFilter } from './genre-filter'
import { SearchInput } from './search-input'
import { useEventFilters, type Genre } from './use-event-filters'

type EventFiltersProps = {
	genres: Genre[]
	cities: string[]
	initialFilters: {
		search?: string
		date?: string
		genre?: string[]
		city?: string[]
	}
}

export function EventFilters({
	genres,
	cities,
	initialFilters,
}: EventFiltersProps) {
	const {
		searchInput,
		setSearchInput,
		dateOpen,
		setDateOpen,
		selectedDate,
		setSelectedDate,
		genreOpen,
		setGenreOpen,
		genreSearch,
		setGenreSearch,
		selectedGenres,
		setSelectedGenres,
		cityOpen,
		setCityOpen,
		citySearch,
		setCitySearch,
		selectedCities,
		setSelectedCities,
		performSearch,
	} = useEventFilters({
		initialSearch: initialFilters.search,
		initialDate: initialFilters.date,
		initialGenres: initialFilters.genre,
		initialCities: initialFilters.city,
	})

	return (
		<div className="mb-8 flex w-full flex-col flex-wrap gap-2 lg:flex-row">
			<div className="flex flex-1 gap-2">
				{/* Search Input */}
				<SearchInput value={searchInput} onChange={setSearchInput} />

				{/* Date Filter */}
				<DateFilter
					selectedDate={selectedDate}
					onSelect={(date) => {
						setSelectedDate(date)
						performSearch({ date })
					}}
					open={dateOpen}
					onOpenChange={setDateOpen}
				/>
			</div>
			<div className="flex flex-1 flex-wrap gap-2">
				{/* Genre Filter */}
				<GenreFilter
					genres={genres}
					selectedGenres={selectedGenres}
					onSelect={(newGenres) => {
						setSelectedGenres(newGenres)
						// Defer the search to avoid immediate popover close
						setTimeout(() => {
							performSearch({ genres: newGenres })
						}, 0)
					}}
					open={genreOpen}
					onOpenChange={setGenreOpen}
					searchValue={genreSearch}
					onSearchChange={setGenreSearch}
				/>

				{/* City Filter */}
				<CityFilter
					cities={cities}
					selectedCities={selectedCities}
					onSelect={(newCities) => {
						setSelectedCities(newCities)
						// Defer the search to avoid immediate popover close and scrolling issues
						setTimeout(() => {
							performSearch({ cities: newCities })
						}, 0)
					}}
					open={cityOpen}
					onOpenChange={setCityOpen}
					searchValue={citySearch}
					onSearchChange={setCitySearch}
				/>
			</div>
		</div>
	)
}
